(() => {
  const root = document.documentElement;
  const marker = '5loop:internal-navigation';
  const loader = document.querySelector('[data-site-loader]');
  const progress = document.querySelector('[data-page-progress]');
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');

  const delay = (duration) => new Promise((resolve) => setTimeout(resolve, duration));

  if (root.dataset.searchRedirect && root.dataset.designMode !== 'true') {
    const logo = loader?.querySelector('img');
    const logoReady = logo?.decode ? logo.decode().catch(() => undefined) : Promise.resolve();
    Promise.race([logoReady, delay(500)]).then(() => {
      requestAnimationFrame(() => requestAnimationFrame(() => {
        try { sessionStorage.setItem('5loop:search-redirect', String(Date.now())); } catch (error) {
          // Redirect still works when storage is unavailable.
        }
        window.location.replace(root.dataset.searchRedirect);
      }));
    });
    return;
  }

  const isInternalLink = (event, link) => {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      link.hasAttribute('download') ||
      link.target === '_blank' ||
      link.dataset.noTransition !== undefined
    ) return false;

    const target = new URL(link.href, location.href);
    if (!['http:', 'https:'].includes(target.protocol) || target.origin !== location.origin) return false;

    const currentWithoutHash = `${location.origin}${location.pathname}${location.search}`;
    const targetWithoutHash = `${target.origin}${target.pathname}${target.search}`;
    return currentWithoutHash !== targetWithoutHash || !target.hash;
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || !isInternalLink(event, link) || root.dataset.designMode === 'true') return;

    try { sessionStorage.setItem(marker, String(Date.now())); } catch (error) {
      // The progress line still works on the current page when storage is blocked.
    }

    if (!progress) return;
    root.dataset.pageProgress = 'outgoing';
    requestAnimationFrame(() => { root.dataset.pageProgress = 'loading'; });
  });

  const completeProgress = () => {
    if (!progress || !root.dataset.pageProgress) return;
    root.dataset.pageProgress = 'complete';
    setTimeout(() => { delete root.dataset.pageProgress; }, 450);
  };

  if (root.dataset.pageProgress === 'incoming') {
    const finishIncoming = () => {
      requestAnimationFrame(() => { requestAnimationFrame(completeProgress); });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', finishIncoming, { once: true });
    } else {
      finishIncoming();
    }
  }

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) completeProgress();
  });

  const closeLoader = () => {
    if (!loader) return;
    delete root.dataset.homeLoader;
    loader.setAttribute('aria-hidden', 'true');
    setTimeout(() => { loader.hidden = true; }, reducedMotion.matches ? 0 : 340);
  };

  if (!loader || root.dataset.homeLoader !== 'pending') {
    delete root.dataset.homeLoader;
    return;
  }

  const minimum = reducedMotion.matches ? 0 : Number(loader.dataset.minDuration) || 0;
  const maximum = Math.max(Number(loader.dataset.maxDuration) || 2500, minimum);
  const startedAt = performance.now();
  const poster = document.querySelector('.campaign-image');
  const domReady = document.readyState === 'loading'
    ? new Promise((resolve) => { document.addEventListener('DOMContentLoaded', resolve, { once: true }); })
    : Promise.resolve();

  const posterReady = !poster
    ? Promise.resolve()
    : typeof poster.decode === 'function'
      ? poster.decode().catch(() => undefined)
      : new Promise((resolve) => {
          if (poster.complete) resolve();
          else {
            poster.addEventListener('load', resolve, { once: true });
            poster.addEventListener('error', resolve, { once: true });
          }
        });

  Promise.race([Promise.all([domReady, posterReady]), delay(maximum)])
    .then(() => delay(Math.max(0, minimum - (performance.now() - startedAt))))
    .then(closeLoader);
})();
